import type {
  AllowedLocaleCountry,
  AllowedLocaleLanguage,
  Locale,
} from '../types/locale'
import {
  allowedLocaleCountries,
  allowedLocaleLanguages,
  locales,
} from '../types/locale'

export const isValidLocale = (locale: string): locale is Locale =>
  locales.includes(locale as Locale)

export const isValidLanguage = (
  language: string,
): language is AllowedLocaleLanguage =>
  allowedLocaleLanguages.includes(language as AllowedLocaleLanguage)

export const isValidCountry = (
  country: string,
): country is AllowedLocaleCountry =>
  allowedLocaleCountries.includes(country as AllowedLocaleCountry)

export const createLocale = (
  language: AllowedLocaleLanguage,
  country: AllowedLocaleCountry,
): Locale => {
  const locale = `${language}-${country}`
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return locale
}
